import {
  createSuccessResponse,
  createFailResponse,
  createErrorResponse,
} from "client/utils/apiResponses";
import constants from "client/utils/constants";
import config from "server/envConfig";

const fetchData = (req, mock = false) => {
  const baseUrl = config.firebase.baseUrl;

  const { endpoint } = req.config;

  const path = mock ? endpoint : `${baseUrl}${endpoint ? endpoint : ""}`;

  const response = fetch(path, {
    headers: constants.headers,
  })
    .then(async (response) => {
      if (response.status !== 200) {
        const result = { success: false, ...response };
        return createFailResponse(result);
      }
      const responseData = await response.json();

      const content = Array.isArray(responseData)
        ? responseData
        : [responseData];

      const result = { success: true, content };

      return createSuccessResponse(result);
    })
    .catch((err) => {
      const result = { success: false, error: err };
      return createErrorResponse(result);
    });

  return response;
};

export default fetchData;
